import { useMemo, useEffect, useState } from 'react';
// eslint-disable-next-line no-unused-vars
import { Container, Button, Row, Col } from 'react-bootstrap';
import { withStore } from 'store';
import GiftsLayout from 'components/gifts-table/GiftsLayout';
// eslint-disable-next-line no-unused-vars
import GenericHeroHeader from 'components/gifts-table/GenericHeroHeader';
import TableShareWidget from 'components/gifts-table/TableShareWidget';
import { getGiftTableLink } from 'services/commons';
// eslint-disable-next-line no-unused-vars
import iconregalo from 'assets/img/iconregalo.svg';
import styles from './style.module.scss';
import PrintQrMobile from 'components/Cards/PrintQR/PrintQrMobile';
import { useStorage64Latin } from 'hooks';
import { CURRENT_GIFT_TABLE } from 'constants/storage64';
import { HeaderMobile } from 'components/Mobile';
function ShareTable({
  giftTable,
  loading,
}) {
  
  const url = useMemo(
    () => (loading ? '' : getGiftTableLink(giftTable)),
    [giftTable, loading]
  );

  const [giftTableInfo, setGiftTableInfo] = useState({})

  const handlerFestejados = (giftTableInfo) =>{
    const festejados = giftTableInfo.celebrate_labels?.map(c => c.label.value.trim());
    return  festejados ? festejados.join(' & ') : giftTableInfo.festejados ; 
  }

  useEffect(() => {
    console.log("+++++++++++++++++++++++")
    console.log(giftTable)
    console.log("+++++++++++++++++++++++")
    setGiftTableInfo(giftTable)
  }, [giftTableInfo])
  


  return <>
    <HeaderMobile title="Compartir mi mesa"></HeaderMobile>
    <section className={styles.ThankYou}>
    <Container  className={styles.containerBg}>
      <Row className="justify-content-md-center">
     
        <Col md="auto" className={styles.contentQr}>
        <PrintQrMobile url={url} title={giftTableInfo?.name || giftTableInfo?.nombre} evento={giftTableInfo?.name || giftTableInfo?.nombre} celebrate={handlerFestejados(giftTableInfo)} image={giftTableInfo.image}/>
        </Col>
      </Row>
      
      </Container>
    </section>
  </>
};

export default withStore({
  mapStateToProps: (state) => ({
    giftTable: state.giftTable.giftTable,
    loading: state.giftTable.giftTableInfo.loading,
  }),
})(ShareTable);
